import React, { useRef,useEffect } from "react";
import { motion } from "framer-motion";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../styles/Contactpage.css";
import contactVideo from "../assets/vid8.mp4";

const ContactPage = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_mfkas6m", // Replace with your EmailJS service ID
        "template_3gajdpw", // Replace with your EmailJS template ID
        form.current,
        "QxX2gDoh7vW8Lh-bw" // Replace with your EmailJS public key
      )
      .then(
        () => {
          toast.success(" Message sent successfully!");
          form.current.reset();
        },
        () => {
          toast.error("❌ Failed to send message. Please try again.");
        }
      );
  };

  return (
    <div className="contact-container">
      {/* Background Video */}
      <video className="contact-video" autoPlay loop muted playsInline>
        <source src={contactVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="contact-overlay" />

      {/* Toast Container */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Main Content */}
      <div className="contact-wrapper">
        {/* Left Side */}
        <motion.div
          className="contact-left"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="contact-left-content">
            <h1>Get in Touch</h1>
            <p>
              Whether you have a question or a project in mind, reach out and
              let's connect.
            </p>
          </div>
        </motion.div>

        {/* Right Side */}
        <motion.div
          className="contact-right"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <form ref={form} onSubmit={sendEmail} className="contact-form">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Your name"
              required
            />

            <label htmlFor="email">Email</label>
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Your email"
              required
            />

            <label htmlFor="message">Message</label>
            <textarea
              name="message"
              id="message"
              rows="5"
              placeholder="Your message"
              required
            />

            <button type="submit">Send Message</button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default ContactPage;
